import { render, staticRenderFns } from "./otherReceipts.vue?vue&type=template&id=4d1875dc&scoped=true"
import script from "./otherReceipts.vue?vue&type=script&lang=js"
export * from "./otherReceipts.vue?vue&type=script&lang=js"
import style0 from "./otherReceipts.vue?vue&type=style&index=0&id=4d1875dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1875dc",
  null
  
)

export default component.exports